exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.v-event.v-event-start.v-event-end.theme{color:#06017a!important;border:1px solid #06017a!important;background-color:#fff!important}div.v-calendar-weekly__day.v-present>div>button{color:#fff}", ""]);

// exports
